export const MODULE_KEYS = {
    ANALYTICS: "ANALYTICS",
    VISUALS: "VISUALS",
    AUDIOS_SUB_CATEGORY: "AUDIOS_SUB_CATEGORY",
    GOALS_SUB_CATEGORY: "GOALS_SUB_CATEGORY",

    AUTHOR: "AUTHOR",
    NARRATOR: "NARRATOR",
    AUDIO_BY_ID: "AUDIO_BY_ID",

    SINGLE_AUDIO_MANAGEMENT: "SINGLE_AUDIO_MANAGEMENT",
    SERIES_AUDIO_MANAGEMENT: "SERIES_AUDIO_MANAGEMENT",
    SERIES_DETAILS_AUDIO_MANAGEMENT: "SERIES_DETAILS_AUDIO_MANAGEMENT",
    ONBOARDING_AUDIO_MANAGEMENT: "ONBOARDING_AUDIO_MANAGEMENT",

    USER_MANAGEMENT_LISTING: "USER_MANAGEMENT_LISTING",
    NOTIFICATION_MANAGEMENT_LISTING: "NOTIFICATION_MANAGEMENT_LISTING",

    USER_MANAGEMENT_DETAILS: "USER_MANAGEMENT_DETAILS",

    ADD_NOTIFICATION: "ADD_NOTIFICATION",
    UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",

    PROFILE_UPDATED: "PROFILE_UPDATED",
    ACCOUNT_CHANGE_PASSWORD: "ACCOUNT_CHANGE_PASSWORD"
};

export const getKey = (keys = [], params = {}) => {
    const KEYS = [...keys];

    const hasParams = Object.keys(params);

    if (hasParams.length) {
        KEYS.push(params);
    }

    return KEYS;
};
